import { defineMessages } from 'react-intl';

const messages = defineMessages({
  inch: {
    description: 'sellerSettings.dimensionUnitOfMeasure.inch',
    defaultMessage: 'Inches',
    id: 'EDxhJH',
  },
  centimeter: {
    description: 'sellerSettings.dimensionUnitOfMeasure.centimeter',
    defaultMessage: 'Centimeters',
    id: 'Otx896',
  },
  ounce: {
    description: 'sellerSettings.dimensionUnitOfMeasure.ounce',
    defaultMessage: 'Pounds & Ounces',
    id: 't/Z0zg',
  },
  gram: {
    description: 'Seller settings dimension unit of measure - Kilograms and Grams display option',
    defaultMessage: 'Kilograms & Grams',
    id: 'huliGL',
  },
  standard: {
    description: 'sellerSettings.productType.standard',
    defaultMessage: 'Standard (Standalone products only)',
    id: 'SxFGzu',
  },
  advanced: {
    description: 'sellerSettings.productType.advanced',
    defaultMessage: 'Advanced (Parents, Variants, and Standalones)',
    id: 'xTZ25M',
  },
  abandon: {
    defaultMessage: 'Treat as Abandoned',
    id: 'cXqk/m',
    description: 'sellerSettings.international.abandon',
  },
  allInternationalShipments: {
    defaultMessage: 'All international shipments',
    id: '+YJRfM',
    description: 'sellerSettings.international.allInternationalShipments',
  },
  documents: {
    defaultMessage: 'Documents',
    id: 'sIpn0k',
    description: 'sellerSettings.international.documents',
  },
  gift: {
    defaultMessage: 'Gift',
    id: '/o8x4o',
    description: 'sellerSettings.international.gift',
  },
  itn: {
    defaultMessage: 'ITN/Tax ID',
    id: '/e4Fi9',
    description: 'sellerSettings.international.itn',
  },
  leaveBlank: {
    defaultMessage: 'Leave blank (enter manually)',
    id: 'qLl2l4',
    description: 'sellerSettings.international.leaveBlank',
  },
  lineItems: {
    defaultMessage: 'International shipments where line items total $2,500',
    id: '2G7ZyS',
    description: 'sellerSettings.international.lineItems',
  },
  merchandise: {
    defaultMessage: 'Merchandise',
    id: 'sD5E17',
    description: 'sellerSettings.international.merchandise',
  },
  orderItems: {
    defaultMessage: 'Create declarations from order items',
    id: '4EsUc/',
    description: 'sellerSettings.international.orderItems',
  },
  preDefinedValues: {
    defaultMessage: 'Use pre-defined values',
    id: 'zcU2Bc',
    description: 'sellerSettings.international.preDefinedValues',
  },
  return: {
    defaultMessage: 'Return to sender',
    id: 'eDXPU7',
    description: 'sellerSettings.international.return',
  },
  returnedGoods: {
    defaultMessage: 'Returned Goods',
    id: 'invb8b',
    description: 'sellerSettings.international.returnedGoods',
  },
  sample: {
    defaultMessage: 'Sample',
    id: 'ZYZjAk',
    description: 'sellerSettings.international.sample',
  },
  uspsExemptionCode: {
    defaultMessage: 'USPS Exemption Code',
    id: '7aGs4P',
    description: 'sellerSettings.international.uspsExemptionCode',
  },
  vatNumber: {
    defaultMessage: 'VAT Number (UK Only)',
    id: 'xckRZS',
    description: 'sellerSettings.international.vatNumber',
  },
  onNewOrders: {
    defaultMessage: 'On New Orders',
    id: 'O3mfef',
    description: 'webhook dropdown hook type On New Orders',
  },
  onNewItems: {
    defaultMessage: 'On New Items',
    id: '/tdxPS',
    description: 'webhook dropdown hook type On New Items',
  },
  onOrdersShipped: {
    defaultMessage: 'On Orders Shipped',
    id: 'VnC9pc',
    description: 'webhook dropdown hook type On Orders Shipped',
  },
  onItemsShipped: {
    defaultMessage: 'On Items Shipped',
    id: 'PPdBms',
    description: 'webhook dropdown hook type On Items Shipped',
  },
  onFulfillmentsShipped: {
    defaultMessage: 'On Fulfillment Shipped',
    id: 'wi5DGL',
    description: 'webhook dropdown hook type On Fulfillment Shipped',
  },
  onFulfillmentsRejected: {
    defaultMessage: 'On Fulfillment Rejected',
    id: 'mjWRwW',
    description: 'webhook dropdown hook type On Fulfillment Rejected',
  },
  onBatchProcessedV2: {
    defaultMessage: '(V2) On Batch Processed',
    id: '7FF3Ja',
    description: 'webhook dropdown hook type On Batch Processed v2',
  },
  onTrackEventV2: {
    defaultMessage: '(V2) On New Track Event',
    id: 'uF2TjI',
    description: 'webhook dropdown hook type On Track Event v2',
  },
  onNewOrderCreatedV2: {
    defaultMessage: '(V2) On New Order Created',
    id: 'hgfIbM',
    description: 'webhook dropdown hook type On New Order Created v2',
  },
  onNewLabelCreatedV2: {
    defaultMessage: '(V2) On New Label Created',
    id: 'err8fe',
    description: 'webhook dropdown hook type On Label Created v2',
  },
  onFulfillmentsShippedV2: {
    defaultMessage: '(V2) On Fulfillment Shipped',
    id: 'pduzIg',
    description: 'webhook dropdown hook type Fulfillment Shipped v2',
  },
  onFulfillmentsRejectedV2: {
    defaultMessage: '(V2) On Fulfillment Rejected',
    id: 'N/LRVu',
    description: 'webhook dropdown hook type New Fulfillment Rejected v2',
  },
  allowShip: {
    description: 'settings.inventorySettings.allow',
    defaultMessage: 'Allow the shipment',
    id: 'ZcQCJG',
  },
  warnShip: {
    description: 'settings.inventorySettings.warn',
    defaultMessage: 'Warn, but allow the shipment',
    id: 'FtRCmo',
  },
  errorShip: {
    description: 'settings.inventorySettings.error',
    defaultMessage: 'Block the shipment',
    id: 'Cw4ezc',
  },
});

const sellerSettingOptions = {
  inch: {
    value: 'Inch',
  },
  centimeter: {
    value: 'Centimeter',
  },
  ounce: {
    value: 'Ounce',
  },
  gram: {
    value: 'Gram',
  },
  standard: {
    value: false,
  },
  advanced: {
    value: true,
  },
  documents: {
    value: 'Documents',
  },
  gift: {
    value: 'Gift',
  },
  merchandise: {
    value: 'Merchandise',
  },
  returnedGoods: {
    value: 'ReturnedGoods',
  },
  sample: {
    value: 'Sample',
  },
  return: {
    value: 'Return',
  },
  abandon: {
    value: 'Abandon',
  },
  orderItems: {
    value: 'orderitems',
  },
  preDefinedValues: {
    value: 'static',
  },
  leaveBlank: {
    value: 'blank',
  },
  lineItems: {
    value: 'LineItems',
  },
  allInternationalShipments: {
    value: 'All',
  },
  itn: {
    value: 'ITN',
  },
  uspsExemptionCode: {
    value: 'Exemption',
  },
  vatNumber: {
    value: 'VAT',
  },
  empty: {
    value: '',
  },
  onNewOrders: {
    value: 'ORDER_NOTIFY',
  },
  onNewItems: {
    value: 'ITEM_ORDER_NOTIFY',
  },
  onOrdersShipped: {
    value: 'SHIP_NOTIFY',
  },
  onItemsShipped: {
    value: 'ITEM_SHIP_NOTIFY',
  },
  onFulfillmentsShipped: {
    value: 'FULFILLMENT_SHIPPED',
  },
  onFulfillmentsRejected: {
    value: 'FULFILLMENT_REJECTED',
  },
  onBatchProcessedV2: {
    value: 'BATCH_PROCESSED_V2',
  },
  onTrackEventV2: {
    value: 'TRACK_EVENT_V2',
  },
  onNewOrderCreatedV2: {
    value: 'SHIPMENT_CREATED_V2',
  },
  onNewLabelCreatedV2: {
    value: 'LABEL_CREATED_V2',
  },
  onFulfillmentsShippedV2: {
    value: 'FULFILLMENT_SHIPPED_V2',
  },
  onFulfillmentsRejectedV2: {
    value: 'FULFILLMENT_REJECTED_V2',
  },
  allowShip: {
    value: 'allow',
  },
  warnShip: {
    value: 'warn',
  },
  errorShip: {
    value: 'error',
  },
};

Object.keys(sellerSettingOptions).forEach((setting) => {
  if (messages[setting]) {
    sellerSettingOptions[setting].messageDescriptor = messages[setting];
  }
});

export default sellerSettingOptions;
